import type { TTranslationKeys } from "$/i18n/i18n"

import { ESessionInvitationStatus } from "@/3514/types"

const sessionStatusTranslationsMap: { [K in ESessionInvitationStatus]: keyof TTranslationKeys } = {
    [ESessionInvitationStatus.Accepted]: "common.sessionStatus.accepted",
    [ESessionInvitationStatus.Present]: "common.sessionStatus.present",
    [ESessionInvitationStatus.Pending]: "common.sessionStatus.pending",
    [ESessionInvitationStatus.Declined]: "common.sessionStatus.declined",
    [ESessionInvitationStatus.NotPresent]: "common.sessionStatus.notPresent",
    [ESessionInvitationStatus.Tentative]: "common.sessionStatus.tentative"
}

export { sessionStatusTranslationsMap }
